import SymphonyXTSBanner from './SymphonyXTSBanner';
import SymphonyXTSSection from './SymphonyXTSSection';

function SymphonyXTS() {
  return (
    <div>
      <SymphonyXTSBanner />
      <SymphonyXTSSection />
    </div>
  );
}

export default SymphonyXTS;